module.exports = __webpack_public_path__ + "media/application/images/pawnbroker_short-term-loans-8c36131fe4385555eba3b4c3b1bd7a79.png";